'use strict'

const VueRecaptcha = require('vue-recaptcha/dist/vue-recaptcha.min.js');

module.exports = {
	name: 'App',

	el: '.faq-form',

	components: {VueRecaptcha},

	data: function () {
		return {
			recaptchaKey: window.grade.siteKey,
			token: '',
		};
	},

	mounted() {
		let url = window.location.search.substring(1);
		let params = new URLSearchParams(url);
		if (params.get("updated")) this.scrollToPostMessage();
	},

	methods: {
		submit: function (e) {
			if (!this.token) {
				e.preventDefault();
				e.stopPropagation();
				console.debug('Getting reCaptcha token...')
				this.$refs.recaptcha.execute();
				window[gtm4wp_datalayer_name].push({'event': 'faqFormSubmit'});
			}
		},

		onVerify: function (response) {
			if (response) {
				this.token = response;
				console.debug('reCaptcha token:', response)
				$("#faq-form").trigger('submit');
			}
		},

		onExpired: function () {
			window[gtm4wp_datalayer_name].push({'event': 'faqFormError', 'faqFormErrorMessage': 'ReCaptcha token expired'});
			console.debug('ReCaptcha token expired')
			this.$refs.recaptcha.reset();
			this.token = '';
		},

		onError: function () {
			window[gtm4wp_datalayer_name].push({'event': 'faqFormError', 'faqFormErrorMessage': 'ReCaptcha error'});
			console.error('ReCaptcha error')
		},

		scrollToPostMessage: function () {
			window[gtm4wp_datalayer_name].push({'event': 'faqFormSubmitSuccessful'});
			$('html,body').animate({
				scrollTop: $('.faq-form-post-message').offset().top - 100
			}, 600);
		}
	}
}
